.veil {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: var(--qs-color-ground-deep);
  animation: veilIn var(--qs-motion-dur-veil) var(--qs-motion-ease-veil);
}

@keyframes veilIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.surface {
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--qs-space-16);
  cursor: pointer;
}

.pausedLabel {
  font-family: var(--qs-font-display);
  font-style: italic;
  font-size: var(--qs-type-display-xs-size);
  color: var(--qs-color-text-muted);
}

// Duration is set inline by the component (spec: "fades to nothing over sixty seconds") — a
// one-off behavioural timing, not a reusable design token, so it stays out of the generated set.
.endedLight {
  animation-name: fadeLight;
  animation-timing-function: ease;
  animation-fill-mode: forwards;
}

@keyframes fadeLight {
  to { opacity: 0; }
}

.exit {
  position: absolute;
  top: var(--qs-space-16);
  inset-inline-end: var(--qs-space-16);
  width: var(--qs-target-min);
  height: var(--qs-target-min);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: var(--qs-color-text-muted);
  cursor: pointer;
  z-index: 1;
}
